module.exports = __webpack_public_path__ + "img/IT0001926255311.ba1b108e.png";